window.customElements.define("layout-toggle", class GridToggle extends HTMLElement {
  constructor() {
    super();
    this.expandedGridViewButton = this.querySelector('#expandedGridViewButton');
    this.standardGridViewButton = this.querySelector('#standardGridViewButton');
    this.smallGridViewButton = this.querySelector('#smallGridViewButton');

    this.expandedGridViewButton.addEventListener('click', this.onButtonClick.bind(this));
    this.standardGridViewButton.addEventListener('click', this.onButtonClick.bind(this));
    this.smallGridViewButton.addEventListener('click', this.onButtonClick.bind(this));

    const gridView = localStorage.getItem("layout-grid-option");
    
    if(gridView == "expanded-grid") {
      this.expandedGridViewButton.click();
    } else if (gridView == "standard-grid") {
      this.standardGridViewButton.click();
    } else if (gridView == "small-grid") {
      this.smallGridViewButton.click();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const colID = event.currentTarget.id;
    if (colID == 'expandedGridViewButton') {

      const expandedGridViewButton = document.querySelectorAll('#expandedGridViewButton');
      const standardGridViewButton = document.querySelectorAll('#standardGridViewButton');
      const smallGridViewButton = document.querySelectorAll('#smallGridViewButton');

      expandedGridViewButton.forEach((element) => {
        document.getElementById('ProductGridContainer').classList.add('grid-large-view');
        document.getElementById('ProductGridContainer').classList.remove('grid-regular-view');
        document.getElementById('ProductGridContainer').classList.remove('grid-small-view');

        element.classList.add('active');
      });
      
      standardGridViewButton.forEach((element) => {
        element.classList.remove('active');
      });

      smallGridViewButton.forEach((element) => {
        element.classList.remove('active');
      });

      localStorage.setItem("layout-grid-option", "expanded-grid");


    } else if (colID == 'standardGridViewButton') {
      const expandedGridViewButton = document.querySelectorAll('#expandedGridViewButton');
      const standardGridViewButton = document.querySelectorAll('#standardGridViewButton');
      const smallGridViewButton = document.querySelectorAll('#smallGridViewButton');

      standardGridViewButton.forEach((element) => {
        document.getElementById('ProductGridContainer').classList.remove('grid-large-view');
        document.getElementById('ProductGridContainer').classList.add('grid-regular-view');
        document.getElementById('ProductGridContainer').classList.remove('grid-small-view');

        element.classList.add('active');
      });
      
      expandedGridViewButton.forEach((element) => {
        element.classList.remove('active');
      });

      smallGridViewButton.forEach((element) => {
        element.classList.remove('active');
      });

      localStorage.setItem("layout-grid-option", "standard-grid");
      
    } else if (colID == 'smallGridViewButton') {

      const expandedGridViewButton = document.querySelectorAll('#expandedGridViewButton');
      const standardGridViewButton = document.querySelectorAll('#standardGridViewButton');
      const smallGridViewButton = document.querySelectorAll('#smallGridViewButton');

      smallGridViewButton.forEach((element) => {
        document.getElementById('ProductGridContainer').classList.remove('grid-large-view');
        document.getElementById('ProductGridContainer').classList.remove('grid-regular-view');
        document.getElementById('ProductGridContainer').classList.add('grid-small-view');

        element.classList.add('active');
      });

      expandedGridViewButton.forEach((element) => {
        element.classList.remove('active');
      });
      
      standardGridViewButton.forEach((element) => {
        element.classList.remove('active');
      });

      localStorage.setItem("layout-grid-option", "small-grid");
    }
  }
});